import HeaderContent from 'component/layout/HeaderContent';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRootStore } from 'store/StoreContextProvider';
import TaskGradeEditBody from './component/TaskGradeEditBody';
import TaskGradeEditBodyEmoticon from './component/TaskGradeEditBodyEmoticon';
import TaskGradeEditBottom from './component/TaskGradeEditBottom';
import TaskGradeEditHeader from './component/TaskGradeEditHeader';
import TaskGradeEditPageStore from './store/TaskGradeEditStore';
import { useFormik } from 'formik';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog } from 'antd-mobile';

import bluePin from '../../assets/image/bluePin.png';
import redPin from '../../assets/image/redPin.png';
import bluePinEmpty from '../../assets/image/bluePinEmpty.png';
import redPinEmpty from '../../assets/image/redPinEmpty.png';

import { CircularProgress, Grid, IconButton, Snackbar, Typography } from '@mui/material';
import useSnackbarMessage from 'shared/snackbar';
import { toJS } from 'mobx';
import CheckModal from './component/CheckModal';
import { useMediaQueryState } from '../../hooks/useMediaQueryState';
import HTMLContentModal from './component/HTMLContentModal';
import HTMLContentAssessModal from './component/HTMLContentAssessModal';

function TaskGradingEditVisiblePage() {
  const { headerStore, loginStore } = useRootStore();
  const pageStore: TaskGradeEditPageStore = useLocalObservable(() => new TaskGradeEditPageStore());
  const [updateMode, setUpdateMode] = React.useState<boolean>(false);
  const location = useLocation();
  const snackbar = useSnackbarMessage();
  const navigate = useNavigate();
  const { isMobile, isOutlook } = useMediaQueryState();
  const [fillBlueIcon, setfillBlueIcon] = React.useState<boolean>(false);
  const [fillRedIcon, setfillRedIcon] = React.useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      grade: 1,
      message: location.state.assess?.userData?.message ?? '',
      emoticon: location.state.assess?.userData?.emoticon ? location.state.assess?.userData?.emoticon : 0,
    },
    // enableReinitialize: true,
    // validationSchema: yup.object({
    //   message: yup.string().min(1).required("코멘트를 작성해주세요."),
    // }),
    // TODO: any 수정
    onSubmit: async (values: any) => {
      console.log('SUBMIT', values, updateMode);

      if (values.emoticon === 0) {
        Dialog.alert({
          content: '이모티콘은 필수항목입니다.',
          confirmText: '확인',
        });
        return;
      }

      let like = 'empty';
      if (fillBlueIcon) {
        like = 'true';
      }
      if (fillRedIcon) {
        like = 'false';
      }
      try {
        if (updateMode) {
          await pageStore.updateAssess(values, like, loginStore.currentUser!);

          // 공개평가이면서, 비공개평가를 안한 경우
          if (!pageStore.task!.userData?.prvDoneIdList?.includes(loginStore.currentUser!.id)) {
            pageStore.setIsCloseModal(true);
            return;
          }

          navigate('/employee-detail', {
            state: { employee: toJS(pageStore.employee) },
          });
        } else {
          await pageStore.createTaskAssess(values, like, loginStore.currentUser!, 'VISIBLE', headerStore.isDoneAssess);

          if (pageStore.task!.userData?.prvDoneIdList?.includes(loginStore.currentUser!.id)) {
            navigate('/employee-detail', {
              state: { employee: toJS(pageStore.employee) },
            });
            return;
          }
          if (headerStore.isDoneAssess) {
            navigate('/employee-detail', {
              state: { employee: toJS(pageStore.employee), isAssessDone: true },
            });
          } else {
            headerStore.setIsDoneAssess(true);
            pageStore.setIsCloseModal(true);
          }
        }
      } catch (err: any) {
        snackbar.error(err.message);
      }
    },
  });

  const handleClose = () => {
    pageStore.setSubmitted(false);
  };

  const handleClickBlueIcon = () => {
    if (fillRedIcon) {
      setfillRedIcon(false);
    }
    setfillBlueIcon(!fillBlueIcon);
  };

  const handleClickRedIcon = () => {
    if (fillBlueIcon) {
      setfillBlueIcon(false);
    }
    setfillRedIcon(!fillRedIcon);
  };

  const onClickCloseOk = () => {
    navigate('/employee-detail/close', {
      state: {
        employee: toJS(pageStore.employee),
        task: toJS(pageStore.task),
      },
    });
  };
  const handleClickCancelModal = () => {
    navigate('/employee-detail', {
      state: { employee: toJS(pageStore.employee) },
    });
    pageStore.setIsCloseModal(false);
  };

  useEffect(() => {
    //console.log("useeffect");
    if (location.state.task && location.state.employee) {
      const task = location.state.task;
      console.log(location.state);
      if (location.state.assess) {
        const assess = location.state.assess;
        pageStore.setAssess(assess);
        setUpdateMode(true);

        if (assess.userData?.like) {
          if (assess.userData?.like === 'true') {
            setfillBlueIcon(true);
          } else if (assess.userData?.like === 'false') {
            setfillRedIcon(true);
          }
        }
      }

      pageStore.setTask(task);
      pageStore.setEmployee(location.state.employee);
      console.log('TASK', task, formik);
      pageStore.setFormik(formik);
    }
    headerStore.setPageTitle('사원명');
  }, []);

  return (
    <HeaderContent>
      <TaskGradeEditHeader title={'PAS - Open Advice'} />
      <Grid style={isMobile ? (isOutlook ? { position: 'absolute', cursor: 'pointer', right: 20, top: 25 } : { position: 'absolute', cursor: 'pointer', right: 60, top: 60 }) : { position: 'absolute', cursor: 'pointer', right: 50, top: 0 }}>
        {fillBlueIcon ? <img src={bluePin} onClick={handleClickBlueIcon} alt='bluePin' /> : <img src={bluePinEmpty} onClick={handleClickBlueIcon} alt='bluePinEmpty' />}
        {fillRedIcon ? (
          <img
            src={redPin}
            style={{
              marginLeft: '15px',
            }}
            onClick={handleClickRedIcon}
            alt='redPin'
          />
        ) : (
          <img
            src={redPinEmpty}
            style={{
              marginLeft: '15px',
            }}
            onClick={handleClickRedIcon}
            alt='redPinEmpty'
          />
        )}
      </Grid>
      <Grid style={{ padding: '20px 20px 100px 20px' }}>
        {pageStore.isLoading ? (
          <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
            <CircularProgress />
          </Grid>
        ) : (
          pageStore.formik && (
            <form onSubmit={pageStore.formik.handleSubmit}>
              <TaskGradeEditBody pageStore={pageStore} isOpenAssess={true} />
              <Typography
                style={{
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '14px',
                  color: 'red',
                }}
              >
                *필수항목
              </Typography>
              <TaskGradeEditBodyEmoticon pageStore={pageStore} />
              <TaskGradeEditBottom pageStore={pageStore} />
            </form>
          )
        )}
      </Grid>

      <CheckModal
        isOpen={pageStore.isCloseModal}
        handleClose={() => pageStore.setIsCloseModal(false)}
        title='비공개 평가를 작성하러 가시겠습니까?'
        content='*향후 Done 항목에서 추가 평가는 가능합니다.'
        onClickOk={onClickCloseOk}
        onClickCancel={handleClickCancelModal}
      />
      <HTMLContentAssessModal pageStore={pageStore} isOpen={pageStore.isHTMLOpen} handleClose={() => pageStore.setIsHTMLOpen(false)} onClickCancel={() => pageStore.setIsHTMLOpen(false)} />
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={pageStore.submitted}
        autoHideDuration={2000}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        onClose={handleClose}
        message={'Your summary has been sent.'}
        action={[
          <IconButton key='close' onClick={handleClose}>
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </HeaderContent>
  );
}

export default observer(TaskGradingEditVisiblePage);
